import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { Component } from './grid.styles';
/**
 * Use the `Grid` component to control grid style.
 * see grid -> https://styled-system.com/api#grid-layout
 */

const Grid = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(Component, _extends({
  ref: ref
}, props)));
Grid.displayName = 'Grid';
export default Grid;